import { environment } from './../../../../../environments/environment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, EventEmitter, Output, HostListener, OnDestroy, Inject } from '@angular/core';
import { RoomInfo, RoomMode } from '../hotel-single.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { SwiperOptions } from 'swiper';
import { DOCUMENT } from '@angular/common';


@Component({
    selector: 'app-hotel-single-inner',
    templateUrl: 'hotel-single-inner.component.html',
    styleUrls: ['../hotel-single.component.css', 'hotel-single-inner.component.css', 'hotel-single-inner.component.scss']
})

export class HotelSingleInnerComponent implements OnInit, OnDestroy, NgxUsefulSwiperModule {

    @Input() roomOffers: Array<RoomInfo>;
    @Input() hotelName;
    @Input() roomsForBooking;
    @Input() nights;
    @Input() cards;
    @Input() isClicked;
    @Input() isTextHighlited;
    @Input() hotelInfo;
    @Input() bookingRequest;
    @Output() optionsChanged: EventEmitter<any> = new EventEmitter();

    config: SwiperOptions = {
        pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 30
    };

    isVilla: Boolean = false;

    isRateVisisble: Map<Number, Boolean>;
    cancellationUntil: Map<Number, String>;

    spacesMapped: Map<Number, String>;

    backendRoot = environment.backendRoot;
    descriptionVisible: Array<boolean>;
    experienceVisible: Array<boolean>;
    roomVisible: Array<boolean>;
    mealstotal: Array<number>;
    experiencesTotal: Array<number>;
    selectedMeals = new Map();
    selectedExperiences = new Map();
    selectedRooms = new Map<number, number>();

    currentSelectedRooms = new Map<number, number>();

    selectedRoomOptions = new Map<number, SelectedRoomOptions>();
    maxAvailabilitySelected = new Map<number, number>();
    closeResult: string;
    selectedRoom;
    mobileCarouselOpened = false;
    selectedCarouselRoomId = -1;
    experienceDescriptionVisible;
    constructor(private modalService: NgbModal, @Inject(DOCUMENT) private document: Document) { }

    ngOnInit() {
        this.spacesMapped = new Map<Number, String>();
        this.cancellationUntil = new Map<Number, String>();
        this.descriptionVisible = new Array(this.roomOffers.length).fill(false);
        this.experienceDescriptionVisible = new Array(this.roomOffers.length).fill(new Array());
        this.roomOffers.forEach((room, i) => this.experienceDescriptionVisible[i] = new Array(room.experiences.length).fill(false));
        this.experienceVisible = new Array(this.roomOffers.length).fill(false);
        this.roomVisible = new Array(this.roomOffers.length).fill(false);
        this.mealstotal = new Array(this.roomOffers.length).fill(0);
        this.experiencesTotal = new Array(this.roomOffers.length).fill(0);
        this.isRateVisisble = new Map<Number, Boolean>();
        this.roomOffers.forEach((_room, i) => {
            this.isRateVisisble.set(i, false);
        });
        // sort rooms by availability START
        this.roomOffers.sort(function (a, b) {
            return b.availability - a.availability;
        });
        // sort rooms by availability END
        setTimeout(() => {
            const roomElements = document.getElementsByClassName('collapsed') as HTMLCollectionOf<HTMLButtonElement>;
            if (roomElements !== null && roomElements.length > 0) {
                roomElements[0].click();
            }
        }, 0);
        this.hotelInfo.hotel.hotelAccommocationTypeCollection.forEach(type => {
            if (type.accommodationType.name === 'Villas') {
                this.isVilla = true;
            }
        });
        const requestFromDate = new Date(this.hotelInfo.offer.bookingRequest.fromDate);
        const requestFromDateTmp = new Date(this.hotelInfo.offer.bookingRequest.fromDate);
        this.roomOffers.forEach((room, index) => {

            // cancellation until START
            const roomCollection = room.cancellationPolicy.hotelCancellationPolicyDaysCollection;
            const daysLessThan = new Array<number>();
            let maxOfDaysLessThan = 0;

            if (roomCollection) {
                for (let i = 0; i < roomCollection.length; i++) {
                    daysLessThan.push(roomCollection[i].daysLessThan);
                }
                maxOfDaysLessThan = Math.max(...daysLessThan);
            }

            const date = new Date(requestFromDateTmp.setDate(requestFromDateTmp.getDate() - maxOfDaysLessThan));
            if (new Date() < date) {
                this.cancellationUntil.set(index, date.toDateString());
            }
            // cancellation until END

            let count = 1;
            room.sleepingSpacesDetails.forEach(type => {
                for (let i = 0; i < type.hotelRoomTypeSpaceBedsCollection.length; i++) {
                    const bedName = type.hotelRoomTypeSpaceBedsCollection[i].bedType.name;
                    if (this.spacesMapped.has(count)) {
                        this.spacesMapped.set(count, this.spacesMapped.get(count)
                            .concat(', 1 ' + bedName + ' Bed'));
                    } else {
                        this.spacesMapped.set(count, '1 ' + bedName + ' Bed');
                    }
                }
                count++;
            });
        });
    }

    ngOnDestroy() {
        this.modalService.dismissAll();
    }

    /* @HostListener('window:popstate', ['$event'])
    onPopState(event) {
      window.location.reload();
    } */

    getItemArray(size) {
        return new Array(size).fill(0);
    }

    isDescriptionVisible(index) {
        return this.descriptionVisible[index];
    }

    isExperienceVisible(index) {
        return this.experienceVisible[index];
    }

    isRoomVisible(index) {
        return this.roomVisible[index];
    }

    toggleExperienceVisibility(index) {
        this.experienceVisible[index] = !this.experienceVisible[index];
        const x = document.getElementById('addExp' + index);
        if (x.style.display === 'grid') {
            x.style.display = 'none';
        } else {
            x.style.display = 'grid';
        }
    }
    toggleDescriptionVisibility(index) {
        this.descriptionVisible[index] = !this.descriptionVisible[index];
    }

    toggleRoomVisibility(index) {

        this.roomVisible[index] = !this.roomVisible[index];
        const x = document.getElementById('roomWrap' + index);
        if (x.style.display === 'block') {
            x.style.display = 'none';
        } else {
            x.style.display = 'block';
        }

    }

    isHelpIconVisible(index) {
        return (this.roomOffers[index].withCancellationPricingPolicy.title === 'With Cancellation');
    }

    getCostWithCancellationView(index) {
        if (this.roomOffers.length === 0) { return 0; }
        let numOfSelectedRooms = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
        if (!numOfSelectedRooms) {
            numOfSelectedRooms = 1;
        }
        if (this.roomOffers[index].withCancellationOfferPrice > this.roomOffers[index].withCancellationPrice) {
            return this.nights * this.roomOffers[index].withCancellationOfferPrice * numOfSelectedRooms;
        }
        if (this.hasRoomDiscount(index, 0)) {
            return this.nights * this.roomOffers[index].withCancellationOfferPrice * numOfSelectedRooms;
        }
        return this.nights * this.roomOffers[index].withCancellationPrice * numOfSelectedRooms;
    }

    // getCostWithCancellationView(index) {
    //     if (this.roomOffers.length === 0) { return 0; }
    //     let numOfSelectedRooms = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
    //     if (!numOfSelectedRooms) {
    //         numOfSelectedRooms = 1;
    //     }
    //     return this.nights * this.roomOffers[index].withCancellationPrice * numOfSelectedRooms;
    // }

    getOfferCostWithCancellationSingle(index) {
        let numOfSelectedRooms = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
        if (!numOfSelectedRooms) {
            numOfSelectedRooms = 1;
        }
        return this.roomOffers[index].withCancellationOfferPrice * numOfSelectedRooms;
    }

    getCostWithCancellationSingle(index) {
        if (this.roomOffers.length === 0) { return 0; }
        let numOfSelectedRooms = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
        if (!numOfSelectedRooms) {
            numOfSelectedRooms = 1;
        }
        // if (this.hasRoomDiscount(index, 0)) {
        //     return this.nights * this.roomOffers[index].withCancellationOfferPrice;
        // }
        return this.roomOffers[index].withCancellationPrice * numOfSelectedRooms;
    }

    getCostWithCancellation(index, numberOfSelectedRooms) {
        if (this.roomOffers.length === 0) { return 0; }
        if (this.roomOffers[index].withCancellationOfferPrice > this.roomOffers[index].withCancellationPrice) {
            return this.nights * this.roomOffers[index].withCancellationOfferPrice * numberOfSelectedRooms;
        }
        if (this.hasRoomDiscount(index, 0)) {
            return this.nights * this.roomOffers[index].withCancellationOfferPrice * numberOfSelectedRooms;
        }
        return this.nights * this.roomOffers[index].withCancellationPrice * numberOfSelectedRooms;
    }

    getCostNonRefundableView(index) {
        if (this.roomOffers.length === 0) { return 0; }
        let numOfSelectedRooms = this.selectedRooms.get(this.roomOffers[index].nonRefundableID);
        if (!numOfSelectedRooms) {
            numOfSelectedRooms = 1;
        }
        if (this.hasRoomDiscount(index, 1)) {
            return this.nights * this.roomOffers[index].nonRefundableOfferPrice * numOfSelectedRooms;
        }
        return this.nights * this.roomOffers[index].nonRefundablePrice * numOfSelectedRooms;
    }

    getCostNonRefundableSingle(index) {
        if (this.roomOffers.length === 0) { return 0; }
        if (this.hasRoomDiscount(index, 1)) {
            return this.nights * this.roomOffers[index].nonRefundableOfferPrice;
        }
        return this.nights * this.roomOffers[index].nonRefundablePrice;
    }

    getCostNonRefundable(index, numberOfSelectedRooms) {
        if (this.roomOffers.length === 0) { return 0; }
        if (this.hasRoomDiscount(index, 1)) {
            return this.nights * this.roomOffers[index].nonRefundableOfferPrice * numberOfSelectedRooms;
        }
        return this.nights * this.roomOffers[index].nonRefundablePrice * numberOfSelectedRooms;
    }

    sendSelectionsToParent() {
        const selectedOptions = new Map<number, SelectedRoomOptions>();
        if (this.selectedRooms.size === 0) {

        } else {
            this.selectedRooms.forEach((isSelected, id, map) => {
                if (isSelected > 0) {
                    selectedOptions.set(id, this.selectedRoomOptions.get(id));
                }
            });
        }

        this.optionsChanged.emit([selectedOptions]);

    }

    computeMealCosts(roomId, value, meal, index, mode) {
        const costinfo: CostInfo = { quantity: parseInt(value, 10), costPerItem: meal.surchargeAmount };
        if (this.selectedRoomOptions.has(roomId)) {
            this.selectedRoomOptions.get(roomId).roomMealTypes.set(meal.id, costinfo);
        } else {
            const mealTypes = new Map();
            mealTypes.set(meal.id, costinfo);
            const options: SelectedRoomOptions = {
                roomMealTypes: mealTypes,
                experienceTypes: new Map(),
                roomCost: mode === RoomMode.NON_REFUNDABLE ?
                    this.getCostNonRefundableView(index) : this.getCostWithCancellation(index, this.selectedRooms.get(roomId)),
                selectedRooms: value,
                title: ''
            };
            this.selectedRoomOptions.set(roomId, options);
        }

        let sum = 0;
        this.selectedRoomOptions.get(roomId).roomMealTypes.forEach(
            (costInfo, mealId, map) => sum += (costInfo.costPerItem * costInfo.quantity));
        this.mealstotal[index] = sum;
    }

    onMealSelection(value, meal, index) {
        let roomId;
        if (this.roomOffers[index].roomMode === RoomMode.NON_REFUNDABLE) {
            roomId = this.roomOffers[index].nonRefundableID;
            this.computeMealCosts(roomId, value, meal, index, RoomMode.NON_REFUNDABLE);
        } else if (this.roomOffers[index].roomMode === RoomMode.WITH_CANCELLATION) {
            roomId = this.roomOffers[index].withCancellationID;
            this.computeMealCosts(roomId, value, meal, index, RoomMode.WITH_CANCELLATION);
        } else {
            roomId = this.roomOffers[index].nonRefundableID;
            this.computeMealCosts(roomId, value, meal, index, RoomMode.NON_REFUNDABLE);
            roomId = this.roomOffers[index].withCancellationID;
            this.computeMealCosts(roomId, value, meal, index, RoomMode.WITH_CANCELLATION);
        }

        this.sendSelectionsToParent();
    }

    addThisRoom(i, roomTitle) {
        const rate = this.isRateVisisble.get(i);
        if (!rate) {
            this.isRateVisisble.set(i, true);
        }
        setTimeout(() => {
            const select = <HTMLSelectElement>document.getElementById('select-' + i);
            if (select) {
                select.selectedIndex = 1;
                this.onRoomSelection(1, i, 0, roomTitle);
            }
        }, 200);
    }

    onRoomSelection(value, index, option, roomTitle) {
        let roomId;
        value = parseInt(value, 10);
        if (value > 0) {
        }
        if (value === 0) {
            this.isRateVisisble.set(index, false);
        }
        if (option === 0) { // With cancellation selected
            this.selectedRooms.set(this.roomOffers[index].withCancellationID, value);
            roomId = this.roomOffers[index].withCancellationID;
        } else {
            this.selectedRooms.set(this.roomOffers[index].nonRefundableID, value);
            roomId = this.roomOffers[index].nonRefundableID;
        }

        if (value === 0) {
            this.currentSelectedRooms.delete(roomId);
        }
        const roomTypeId = this.roomOffers[index].roomTypeId;
        const element = <HTMLElement>document.getElementById(index + 'room');
        this.currentSelectedRooms.set(roomId, roomTypeId);
        this.currentSelectedRooms.forEach((keyValue: number, key: number) => {
            if ((key - 1 === roomId && keyValue === roomTypeId) ||
                (key + 1 === roomId && keyValue === roomTypeId) && value > 0) {
                // element.innerText = '0€';
            }
        });

        let cancelationSelected = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
        let nonRefundableSelected = this.selectedRooms.get(this.roomOffers[index].nonRefundableID);
        if (!cancelationSelected) { cancelationSelected = 0; }
        if (!nonRefundableSelected) { nonRefundableSelected = 0; }

        if (!this.selectedRoomOptions.has(roomId)) {
            if (option === 0) {
                const options: SelectedRoomOptions = {
                    roomMealTypes: new Map(),
                    experienceTypes: new Map(),
                    roomCost: this.getCostWithCancellation(index, cancelationSelected),
                    selectedRooms: value,
                    title: roomTitle
                };
                this.selectedRoomOptions.set(roomId, options);
            } else {
                const options: SelectedRoomOptions = {
                    roomMealTypes: new Map(),
                    experienceTypes: new Map(),
                    roomCost: this.getCostNonRefundable(index, nonRefundableSelected),
                    selectedRooms: value,
                    title: roomTitle
                };
                this.selectedRoomOptions.set(roomId, options);
            }

        } else {
            if (value === 0) {
                this.selectedRoomOptions.delete(roomId);
                // this.experiencesTotal[index] = 0;

            } else {
                if (option === 0) {
                    const options: SelectedRoomOptions = {
                        roomMealTypes: new Map(),
                        experienceTypes: this.selectedRoomOptions.get(roomId).experienceTypes,
                        roomCost: this.getCostWithCancellation(index, cancelationSelected),
                        selectedRooms: value,
                        title: roomTitle
                    };
                    this.selectedRoomOptions.set(roomId, options);
                } else {
                    const options: SelectedRoomOptions = {
                        roomMealTypes: new Map(),
                        experienceTypes: this.selectedRoomOptions.get(roomId).experienceTypes,
                        roomCost: this.getCostNonRefundable(index, nonRefundableSelected),
                        selectedRooms: value,
                        title: roomTitle
                    };
                    this.selectedRoomOptions.set(roomId, options);
                }
            }
        }
        this.sendSelectionsToParent();
    }

    getOptionsCancellation(size, index, option) {
        let cancelationSelected = this.selectedRooms.get(this.roomOffers[index].withCancellationID);
        let nonRefundableSelected = this.selectedRooms.get(this.roomOffers[index].nonRefundableID);
        if (!cancelationSelected) { cancelationSelected = 0; }
        if (!nonRefundableSelected) { nonRefundableSelected = 0; }
        if (option === 'WITH_CANCELLATION') {
            return new Array(size - nonRefundableSelected).fill(1);
        } else {
            return new Array(size - cancelationSelected).fill(1);
        }
    }

    computeExperiencesCosts(roomId, value, experience, index, mode, roomTitle) {
        const costinfo: CostInfo = { quantity: parseInt(value, 10), costPerItem: experience.surchargeAmount };
        if (this.selectedRoomOptions.has(roomId)) {
            this.selectedRoomOptions.get(roomId).experienceTypes.set(experience.id, costinfo);
            this.selectedRoomOptions.get(roomId).experienceTitleCost = new Map();
            this.selectedRoomOptions.get(roomId).experienceTitleCost.set(experience.title, value);
        } else {
            const expTypes = new Map();
            expTypes.set(experience.id, costinfo);
            const rawExp = new Map();
            rawExp.set(experience.title, costinfo);
            const options: SelectedRoomOptions = {
                roomMealTypes: new Map(),
                experienceTypes: expTypes,
                roomCost: RoomMode.NON_REFUNDABLE ?
                    this.getCostNonRefundableView(index) : this.getCostWithCancellation(index, this.selectedRooms.get(roomId)),
                selectedRooms: value,
                title: roomTitle,
                experienceTitleCost: rawExp
            };
            this.selectedRoomOptions.set(roomId, options);
        }

        let sum = 0;
        this.selectedRoomOptions.get(roomId).experienceTypes.forEach(
            (costInfo, experienceId, map) => sum += (costInfo.costPerItem * costInfo.quantity));
        this.experiencesTotal[index] = sum;
    }

    onExperienceSelection(value, experience, index, roomTitle) {
        let roomId;
        if (this.roomOffers[index].roomMode === RoomMode.NON_REFUNDABLE) {
            roomId = this.roomOffers[index].nonRefundableID;
            this.computeExperiencesCosts(roomId, value, experience, index, RoomMode.NON_REFUNDABLE, roomTitle);
        } else if (this.roomOffers[index].roomMode === RoomMode.WITH_CANCELLATION) {
            roomId = this.roomOffers[index].withCancellationID;
            this.computeExperiencesCosts(roomId, value, experience, index, RoomMode.WITH_CANCELLATION, roomTitle);
        } else {
            roomId = this.roomOffers[index].nonRefundableID;
            this.computeExperiencesCosts(roomId, value, experience, index, RoomMode.NON_REFUNDABLE, roomTitle);
            roomId = this.roomOffers[index].withCancellationID;
            this.computeExperiencesCosts(roomId, value, experience, index, RoomMode.WITH_CANCELLATION, roomTitle);
        }

        this.sendSelectionsToParent();

    }

    getClass(meal) {
        return meal.title.toLowerCase().replace('children', '')
            + ' ' + meal.title.toLowerCase().replace(/ /g, '-') + ' '
            + meal.title.toLowerCase().split(' ')[0];
    }


    open(content, room) {
        this.selectedRoom = room;
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title', size: 'lg',
            windowClass: 'carousel-modal'
        }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });

    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    hasRoomDiscount(index: number, mode) {
        let price;
        let offerPrice;
        if (mode === 0) {
            price = this.roomOffers[index].withCancellationPrice;
            offerPrice = this.roomOffers[index].withCancellationOfferPrice;
        } else {
            price = this.roomOffers[index].nonRefundablePrice;
            offerPrice = this.roomOffers[index].nonRefundableOfferPrice;
        }
        if (price > offerPrice) {
            return true;
        } else {
            return false;
        }
    }

    triggerMenu(option: string, index: number, openClose: boolean) {
        if (option === 'policy') {
            const modal = <HTMLDivElement>document.getElementById('md-modalPolicies-' + index);
            if (openClose) {
                this.document.body.setAttribute('style', 'overflow-y: hidden !important');
                modal.classList.add('md-show');
            } else {
                this.document.body.removeAttribute('style');
                modal.classList.remove('md-show');
            }
        } else if (option === 'experience') {
            const modal = <HTMLDivElement>document.getElementById('md-modalExperiences-' + index);
            if (openClose) {
                this.document.body.setAttribute('style', 'overflow-y: hidden !important');
                modal.classList.add('md-show');
            } else {
                this.document.body.removeAttribute('style');
                modal.classList.remove('md-show');
            }
        }
    }

    getDiscount(offerPrice, price) {
        return Math.floor(100 * (price - offerPrice) / price);
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }


    closeDescriptionVisibility(id) {
        this.mobileCarouselOpened = false;
        this.selectedCarouselRoomId = -1;
    }

    toggleMobileCarousel(roomId) {
        this.mobileCarouselOpened = true;
        this.selectedCarouselRoomId = roomId;
    }

    isMobileRoomCarouselOpen(id) {
        if (id === this.selectedCarouselRoomId) {
            return this.mobileCarouselOpened;
        }
        return false;
    }

    onSlideRoom({ prev, current, direction }) {
        if (this.selectedRoom.pictures[current]) {
            this.selectedRoom.pictures[current].preloaded = true;
        }
        if (this.selectedRoom.pictures[current + 1]) {
            this.selectedRoom.pictures[current + 1].preloaded = true;
        }
    }

    onSlideMoreInfoPics({ prev, current, direction }, room) {
        if (room.pictures[current]) {
            room.pictures[current].preloaded = true;
        }
        if (room.pictures[current + 1]) {
            room.pictures[current + 1].preloaded = true;
        }
    }


    getArray(size) {
        return new Array(size).fill(1);
    }


    readMore(roomIndex, experienceindex) {
        this.experienceDescriptionVisible[roomIndex][experienceindex] = !this.experienceDescriptionVisible[roomIndex][experienceindex];
    }

    isExperienceDescriptionVisible(roomIndex, experienceindex) {
        return this.experienceDescriptionVisible[roomIndex][experienceindex];
    }

    checkTitle() {
        const x = document.getElementById('exp-title');
        if (x.innerHTML === 'Netflix' || x.innerHTML === 'Long Term Manicure') {
            return true;
        }

        return false;
    }

}

export interface SelectedRoomOptions {
    roomMealTypes: Map<number, CostInfo>;
    experienceTypes: Map<number, CostInfo>;
    roomCost: number;
    selectedRooms: number;
    title: String;
    experienceTitleCost?: Map<number, String>;
}

export interface CostInfo {
    quantity: number;
    costPerItem: number;
}
